import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import CountdownTimer from '../CountdownTimer/CountdownTimer.jsx';
import MainContent from '../MainContent/MainContent.jsx';

import 'bootstrap-icons/font/bootstrap-icons.css';
import "./MainPage.css"

function MainPage() {
  const eventDate = '2026-05-09T09:00:00';

  return (
    <>
      <Row className="flex-nowrap">
        <img width="1920px" height="1080px"
          src={`${process.env.PUBLIC_URL}/images/konferencja_main_01.png`}
          alt="Conference Banner"
          className="img-fluid w-100"
          max-width="1920px" max-height="1080px"
        />
      </Row>
      <Row className="justify-content-center countdownTimerRow">
        <Col xs={12} sm={12} md={10} lg={10} xl={8}>
          <CountdownTimer targetDate={eventDate} />
        </Col>
      </Row>
      <Row>
        <Row className="registerButtonMobile d-none d-md-block justify-content-center">
          <Col className="d-block d-md-none">
            <Button className="registerButton" href="#section_register">
              <i className="bi bi-pencil-square"></i> REJESTRACJA
            </Button>
          </Col>
        </Row>
        <MainContent />
      </Row>
    </>
  );
}

export default MainPage;
